import { render } from "./index.vue?vue&type=template&id=3ecccb56&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3ecccb56&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.22_typescript@5.8.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecccb56"],['__file',"src/components/svg-icon/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ecccb56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ecccb56', __exports__)) {
    api.reload('3ecccb56', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3ecccb56&scoped=true", () => {
    api.rerender('3ecccb56', render)
  })

}


export default __exports__